import './index.css';
import Header from './components/Header/Header';
import Nav from './components/Nav/Nav';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Services from './components/services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';


function App() {
  return (
    <>
      <Header/>
      <Nav/>
      <About/>
      <Experience/>
      {/* <Services/> */}
      {/* <Portfolio/> */}
      
      <Projects/>
      <Contact/>
      <Footer/>
      
    </>
  );
}

export default App;
